import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Capacitor } from '@capacitor/core';
import { PushNotifications } from '@capacitor/push-notifications';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AppService } from '../../../../services/app.service';
import { RtI18nDirective } from '../runtime-translation.directive';

/**
 * The Direct Messages / Posts / Critical Alerts notification toggles shared by the profile page and
 * the first-login communication-preferences modal. The host form must contain the controls:
 * directMessageEmail, directMessageText, directMessagePush, directMessageToast, postEmail, postText,
 * postPush and criticalAlertPhone. The push toggles' enabled state is owned by the host; this
 * component only re-evaluates it after the user grants/denies permission via the App Settings link.
 */
@Component({
  selector: 'app-communication-preference-toggles',
  standalone: true,
  templateUrl: './communication-preference-toggles.component.html',
  styleUrl: './communication-preference-toggles.component.scss',
  imports: [ReactiveFormsModule, MatSlideToggleModule, MatTooltipModule, RtI18nDirective]
})
export class CommunicationPreferenceTogglesComponent {
  @Input({ required: true }) form!: FormGroup;

  isNativePlatform = Capacitor.isNativePlatform();

  constructor(private appService: AppService) {}

  get systemPushPermissionGranted(): boolean {
    return this.appService.getSystemPushPermissionGranted;
  }

  async openAppSettings(): Promise<void> {
    const permission = await PushNotifications.requestPermissions();
    if (permission.receive === 'granted') {
      this.appService.setSystemPushPermissionGranted = true;
    } else {
      this.appService.openAppSettings();
    }
    this.updatePushControlsDisabledState();
  }

  private updatePushControlsDisabledState(): void {
    if (this.isNativePlatform && this.systemPushPermissionGranted) {
      this.form.get('directMessagePush')?.enable();
      this.form.get('postPush')?.enable();
    } else {
      this.form.get('directMessagePush')?.disable();
      this.form.get('postPush')?.disable();
    }
  }
}
